var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecording(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_367_5519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0938 5.75C15.0938 3.76523 13.4848 2.15625 11.5 2.15625C9.51523 2.15625 7.90625 3.76523 7.90625 5.75V11.5C7.90625 13.4848 9.51523 15.0938 11.5 15.0938C13.4848 15.0938 15.0938 13.4848 15.0938 11.5V5.75Z",
    fill: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0938 5.75C15.0938 3.76523 13.4848 2.15625 11.5 2.15625C9.51523 2.15625 7.90625 3.76523 7.90625 5.75V11.5C7.90625 13.4848 9.51523 15.0938 11.5 15.0938C13.4848 15.0938 15.0938 13.4848 15.0938 11.5V5.75Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.8,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 18.1719V20.7031",
    stroke: "#1A1A1A",
    strokeWidth: 1.8,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3604 11.7031C18.3604 13.4187 17.6376 15.0641 16.351 16.2772C15.0644 17.4903 13.3195 18.1719 11.5 18.1719C9.68052 18.1719 7.93556 17.4903 6.649 16.2772C5.36243 15.0641 4.63965 13.4187 4.63965 11.7031",
    stroke: "#1A1A1A",
    strokeWidth: 1.8,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_367_5519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecording);
export default __webpack_public_path__ + "static/media/recording.8451dd58.svg";
export { ForwardRef as ReactComponent };